import React from 'react'
import { useTranslation } from 'react-i18next'
import { ModalProps } from 'antd'
import styled from 'styled-components'
import Button from '@components/ui/Button'
import Flex from '@components/ui/Flex'
import Hr from '@components/ui/Hr'
import Modal from '@components/ui/Modal/Modal'
import useVisible from '@/hooks/useVisible'
import localStorageUtil from '@/utils/localstorage'

const LoginAnnounceModal = (props: ModalProps) => {
  const { t } = useTranslation('common')

  const [isAgree, setIsAgree] = React.useState(localStorageUtil.get('isAgreeAnnounce'))

  const { visible, open, close } = useVisible()

  const handleOk = () => {
    localStorageUtil.set('isAgreeAnnounce', true)
    setIsAgree(true)
    close()
  }

  React.useEffect(() => {
    if (isAgree) {
      return
    }

    open()
    // eslint-disable-next-line
  }, [isAgree])

  return (
    <Modal
      {...props}
      width="66%"
      bodyStyle={{
        padding: '0px 30px 80px 30px',
        minHeight: 200,
        maxHeight: '90vh',
        overflow: 'auto',
      }}
      visible={visible}
      closable={false}
      maskClosable={false}
      confirmLoading={false}
      footer={null}
      title={
        <div>
          <h2>使用條款及免責聲明</h2>
          <Hr />
        </div>
      }>
      <StyledContent>
        <p>使用條款及免責聲明</p>
        <p>
          本網站由「信星資訊股份有限公司」所經營。本網站重視每一個使用者所享有的服務，特此說明本網站的使用政策，以保障您的權益。請您細讀本使用條款的內容：
        </p>
        <section>
          <h3>關於《使用條款》</h3>
          <ol type="1">
            <li>
              在您決定使用本網站所提供的服務(以下簡稱本服務)前，請仔細閱讀本使用條款。您必須在完全同意以下條款的前提下，才能使用本服務。本使用條款與其他附加條件或其他特殊條款相矛盾時，以附加條件或特殊條款為準。
            </li>
            <li>
              本網站有權於任何時間修改或變更本使用條款之內容，您應經常查看以瞭解您當前的權利及義務。若您於本網站為任何修改或變更本使用條款後仍繼續使用本服務，視為您已同意接受本使用條款之修改及變更。
            </li>
          </ol>
        </section>
        <section>
          <h3>服務內容</h3>
          <ol type="1">
            <li>本服務的具體內容由本網站根據實際情況提供，並對其所提供之服務擁有最終解釋權。</li>
            <li>
              本服務係透過網際網路提供您各項網路資訊服務，您必須自行配備上網所需的各項電腦設備，並承擔所需的費用。
            </li>
          </ol>
        </section>
        <section>
          <h3>授權</h3>
          <p>
            在本使用條款的約束下，本網站僅此授予您有限、僅供申請人使用，禁止其他商業用途、非專屬和不可轉讓的使用本服務。
          </p>
        </section>
        <section>
          <h3>使用者的行為</h3>
          您在使用本網站服務過程中，必須遵循以下原則：
          <ol type="a">
            <li>遵守中華民國有關的法律和法規；</li>
            <li>遵守所有與網路服務有關的網路協定、規定和程式；</li>
            <li>不得為任何非法目的而使用網路服務系統；</li>
            <li> 不使用任何設備、軟體或程序，干擾或試圖干擾本網站、本網站之正常運作；</li>
            <li>
              不允許侵入、強行入侵、接通、使用或企圖侵入、接通、使用本網站伺服器及未經本網站對您發出許可的任何資料區；
            </li>
            <li>不得限制、制止其他使用者使用並享用本服務；</li>
            <li>如發現任何非法使用帳號或任何出現安全漏洞的情況，應立即告知本網站。</li>
          </ol>
        </section>
        <section>
          <h3>知識產權</h3>
          <p>
            本網站中所顯示之所有服務內容（包括但不限於：文字、照片、圖形、圖像、圖表等）、商標、品牌名稱、標誌及其他智慧財產（下稱「智慧財產」），均屬信星之財產。我們並未直接或間接授予存取本網站的任一方使用或重製任何智慧財產的權利或授權，存取本網站的任一方均不得要求與其相關之任何權利、所有權或權益。使用或存取本服務即表示您同意遵守保護本服務、網站及其內容之著作權、商標及所有其他適用的法律。您同意不得複製、散布、再發行、傳輸、公開展示、公開表演、修改、調整、租賃或販售本服務、網站或其內容之任何部分，亦不得據此創作衍生作品。如未事先獲得我們的書面同意，您亦不得用鏡像或框架方式將本網站的任何部分或完整內容放置於任何其他伺服器上或作為任何其他網站的一部分展示。此外，您同意如未事先獲得我們的書面同意，您不會使用任何機器人程式或任何其他自動裝置或手動程序來監視或複製我們的內容。
          </p>
        </section>
        <section>
          <h3>連結</h3>
          <p>
            本網站或所有服務相關網頁上所提供之所有連結，可能連結到其他個人、公司或組織之網站，提供該等連結之目的，僅係為便利使用者自行搜集或取得資訊，本網站對於被連結之該等個人、公司或組織之網站上所提供之產品、服務或資訊，既不擔保其真實性、完整性、即時性或可信度，該等個人、公司或組織亦不因此而當然與本網站有任何僱佣、委任、代理、合夥或其他類似之關係。
          </p>
        </section>
        <section>
          <h3>違約賠償</h3>
          <p>
            您同意保障和維護本網站及任何其他第三方的利益，如因違反有關法律、法規或本使用條款項下的任何條款而致使本網站或任何其他第三方造成損失，您同意承擔所造成損害之賠償責任。
          </p>
        </section>
        <section>
          <h3>拒絕提供擔保</h3>
          <ol type="1">
            <li>
              本網站對本服務不提供任何明示或暗示的擔保，包含但不限於商業適售性、特定目的之適用性及未侵害他人權利。
            </li>
            <li>
              本網站不擔保以下事項：
              <ol type="a">
                <li>本服務將符合您的需求；</li>
                <li>本服務不受干擾、即時提供、安全可靠或從不出錯；</li>
                <li>
                  經由本服務之使用而取得任何資料之合適性、有效性、正確性、完整性、安全性、可靠性、即時性及是否侵害他人權利。
                </li>
              </ol>
            </li>
          </ol>
        </section>
        <section>
          <h3>免責聲明</h3>
          <ol type="1">
            <li>
              本網站會盡量確保資訊正確及適當，但永續知識的發展日新月異，故不能保證資訊皆正確無誤。本網站只供作參考資料用途，目的是提供實用永續資訊收集及計算，如您有其他永續問題，建議尋找永續專門的顧問進行諮詢
            </li>
            <li>
              在任何情況下，本網站對於您或任何其他第三方因使用或不能使用該等服務所發生的任何直接的、間接的、附帶引起的、特別的、懲罰性的或者間接性的損失或損害賠償，不承擔任何責任。即使本網站已知悉可能會有該等損失或損害賠償，亦是如此。
            </li>
            <li>
              本網站於下列情形之一時，得暫停或中斷本服務之部分或全部服務，且對使用者任何直接或間接之損害，不承擔任何責任：
              <ol type="a">
                <li>對於本網站相關系統設備進行遷移、更換或維護時；</li>
                <li>任何不可歸責於之事由所造成之服務停止或中斷；</li>
                <li>天災或其他不可抗力造成本網站之服務停止或中斷；</li>
                <li>使用者有任何違反政府法令或本使用條款情事。</li>{' '}
              </ol>
            </li>
          </ol>
        </section>
        <section>
          <h3>服務變更、中斷或終止</h3>
          <p>鑒於網路服務的特殊性，您同意本網站有權隨時變更、中斷或終止部分或全部的網路服務。</p>
        </section>
        <section>
          <h3>法律管轄</h3>
          <p>
            本使用條款的訂立、執行和解釋及爭議的解決均應適用於中華民國法律，並以台灣台北地方法院作為第一審管轄法院。
          </p>
        </section>
        <section>
          <h3>其他規定</h3>
          <ol type="1">
            <li>
              本使用條款構成雙方對本服務及其他有關事宜的完整協議，並取代雙方先前就本使用條款所為之任何形式之承諾或協議。
            </li>
            <li>
              如本使用條款中的任何條款無論因何種原因，完全或部分無效或不具有執行力，本使用條款的其餘條款仍應有效並且有約束力。
            </li>
            <li>
              本使用條款的標題僅為方便閱讀所設，非對條款的定義、限制、解釋或描述其範圍或界限。
            </li>
          </ol>
        </section>
        <section>
          <h3>聯絡方式</h3>
          <p>若您對於本使用條款或本網站有任何問題或建議，歡迎來信至我們的服務信箱。</p>
          <p>
            E-mail：
            <a href="mailto:sales@startrust.com.tw">sales@startrust.com.tw</a>
          </p>
        </section>
      </StyledContent>
      <Flex justify-end className="mb-40">
        <Button color="primary" onClick={handleOk}>
          {t('agree')}
        </Button>
      </Flex>
    </Modal>
  )
}
export default LoginAnnounceModal

const StyledContent = styled.div`
  counter-reset: section;

  h3 {
    font-size: 16px;

    ::before {
      counter-increment: section;
      content: counter(section) '. ';
      counter-reset: subsection 0;
      counter-reset: subsection-alpha 0;
    }
  }

  ol[type='1'] li {
    counter-increment: subsection;
    line-height: 2em;
    ::before {
      content: counter(subsection) ') ';
    }
  }

  ol[type='a'] li {
    counter-increment: subsection-alpha;
    line-height: 2em;

    ::before {
      content: '(' counter(subsection-alpha, lower-alpha) ') ';
    }
  }
`
